<template>
    <div>
      <!-- DOCUMENTOS PDF -->
      <div class="data-tables-container col-12">
        <div class="col-3 mr-2">
          <Toolbar class="mb-2">
            <template #start>
              <h5>PNAEC'S</h5>
            </template>
            <template #end>
              <Button label="Nuevo" icon="pi pi-plus" @click="agregarPNAEC" class="p-button-success custom-margin" />
              <Button v-if="ID" label="Todos" class="p-button-help" @click="CargaGarantias" />
            </template>
          </Toolbar>
          <dataTable v-model:selection="selectedPNAEC" selectionMode="single" @row-click="onRowSelect" :value="lstPNEC"
            dataKey="Id_pnaec" scrollHeight="65vh" :scrollable="true" :paginator="false" :loading="loading">
            <template #empty>No se encontraron registros</template>
            <template #loading>Cargando Datos. Espere por favor</template>
            <Column field="Nombre" class="col-6" />
            <Column class="col-6">
              <template #body="slotProps">
                <div class="flex justify-content-end">
                  <Button style="width: 35px; height: 35px;" icon="pi pi-pencil"
                    class="p-button-rounded p-button-info p-button-outlined mr-1" @click="editarPNAEC(slotProps.data)" />
                  <Button style="width: 35px; height: 35px;" icon="pi pi-eye"
                    class="p-button-rounded p-button-help p-button-outlined mr-1" @click="verPDF(slotProps.data.URL)" />
                  <Button style="width: 35px; height: 35px;" icon="pi pi-times"
                    class="p-button-rounded p-button-danger p-button-outlined" @click="eliminarPNAEC(slotProps.data)" />
                </div>
              </template>
            </Column>
          </dataTable>
        </div>
        <Dialog :style="{ width: '550px' }" :visible="showDialogPnaec" :modal="true" class="p-fluid" :closable="false">
          <template #header>
            <h3>{{ modoEdicion }}</h3>
          </template>
          <div class="p-formgrid grid">
            <div class="p-field col-12">
              <label for="url">URL PDF</label>
              <FileUpload ref="pdf" mode="basic" :maxFileSize="5000000" :customUpload="true"
                invalidFileSizeMessage="El archivo debe ser de máximo 5MB" chooseLabel="Cargar PDF" uploadLabel="Subir"
                accept="application/pdf" />
            </div>
            <div class="p-field col-6">
              <label for="nombre">Nombre</label>
              <InputText autocomplete="off" id="nombre" v-model.trim="objPNAEC.Nombre" required
                :class="{ 'p-invalid': submitted && !objPNAEC.Nombre }" />
              <small style="color: red;" class="p-invalid" v-if="submitted && !objPNAEC.Nombre">El nombre es
                requerido.</small>
            </div>
            <div class="p-field col-6">
              <label for="proveedor">Proveedor</label>
              <InputText autocomplete="off" id="proveedor" v-model.trim="objPNAEC.Proveedor" required />
            </div>
            <div class="p-field col-12">
              <label for="descripcion">Descripción</label>
              <Textarea autocomplete="off" id="descripcion" v-model.trim="objPNAEC.Descripcion" required
                :class="{ 'p-invalid': submitted && !objPNAEC.Descripcion }" />
              <small style="color: red;" class="p-invalid" v-if="submitted && !objPNAEC.Descripcion">La descripcion es
                requerida.</small>
            </div>
          </div>
          <template #footer>
            <Button label="Cancelar" icon="pi pi-times" @click="cancelarDialogPNAEC" class="p-button-text" />
            <Button label="Guardar" icon="pi pi-check" @click="guardarPNAEC" />
          </template>
        </Dialog>
        <Dialog :style="{ width: '800px' }" :visible="showPDFDialog" :modal="true" class="p-fluid" :closable="false">
          <template #header>
            <h3>Vista Previa del PDF</h3>
          </template>
          <template #footer>
            <Button label="Cerrar" icon="pi pi-times" @click="closePDFDialog" class="p-button-text" />
            <Button label="Navegador" icon="pi pi-globe" @click="verNavegador" class="p-button-primary" />
          </template>
          <iframe :src="pdfURL" style="width: 100%; height: 600px;" frameborder="0"></iframe>
        </Dialog>
        <!-- IMAGENES  -->
        <div class="col-9">
          <Toolbar class="mb-2">
            <template #start>
              <h5>Garantias</h5>
            </template>
            <template #end>
              <Button v-if="ID" label="Nuevo" icon="pi pi-plus" class="p-button-success" @click="agregarGarantia" />
            </template>
          </Toolbar>
          <dataTable :value="lstGarantias" dataKey="Id_pnaec" :scrollable="true" :paginator="true" :rows="5"
            :loading="loading" scrollDirection="both" :filters="filters">
            <template #header>
              <div class="table-header">
                <span>
                  Numero de registros {{ lstGarantias ? lstGarantias.length : 0 }}
                </span>
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                </span>
              </div>
            </template>
            <template #empty>No se encontraron registros</template>
            <template #loading>Cargando Datos. Espere por favor</template>
            <Column style="width: 110px;">
              <template #body="slotProps">
                <Button style="width: 35px; height: 35px;" icon="pi pi-pencil"
                  class="p-button-rounded p-button-info p-button-outlined mr-1" @click="editarGarantia(slotProps.data)" />
                <Button style="width: 35px; height: 35px;" icon="pi pi-eye"
                  class="p-button-rounded p-button-help p-button-outlined mr-1"
                  @click="detallesGarantia(slotProps.data)" />
                <Button style="width: 35px; height: 35px;" icon="pi pi-times"
                  class="p-button-rounded p-button-danger p-button-outlined" @click="eliminarGarantia(slotProps.data)" />
              </template>
            </Column>
            <Column field="Nombre_pnaec" header="PNAEC" v-if="modoEdicion === 'TODOS'" style="width: 100px;" />
            <Column field="Serie" header="Serie" style="width: 140px;" />
            <Column field="Estatus" header="Estatus" style="width: 180px;">
              <template #body="{ data }">
                <span :class="getStatusClass(data.Id_estatus)">{{ getLabelStatus(data.Id_estatus) }}</span>
              </template>
            </Column>
            <Column field="Observacion" header="Observación" style="width: 200px;">
              <template #body="slotProps">
                <textarea v-model="slotProps.data.Observacion" readonly></textarea>
              </template>
            </Column>
            <Column field="Requerimiento" header="Requerimiento" style="width: 130px;" />
            <Column field="Unidad" header="Unidad" style="width: 230px;" />
            <Column field="Fecha" header="Fecha" style="width: 110px;">
              <template #body="{ data }">
                <span>{{ getFechaWCF(data.Fecha) }}</span>
              </template>
            </Column>
          </dataTable>
        </div>
      </div>
      <Dialog :style="{ width: '550px' }" :visible="showDialogGarantia" :modal="true" class="p-fluid" :closable="false">
        <template #header>
          <h3>{{ modoEdicion }}</h3>
        </template>
        <div class="p-formgrid grid">
          <div class="p-field col-12" v-if="modoEdicion === 'Agregar'">
            <label for="url">URL IMG</label>
            <FileUpload ref="img" mode="basic" :maxFileSize="5000000" :customUpload="true" multiple
              invalidFileSizeMessage="El archivo debe ser de máximo 5MB" chooseLabel="Cargar imagen" uploadLabel="Subir"
              accept="image/*" />
          </div>
          <div class="p-field col-6" v-if="modoEdicion === 'Agregar'">
            <label for="serie">Serie</label>
            <InputText autocomplete="off" id="serie" v-model.trim="objGarantia.Serie" required
              :class="{ 'p-invalid': submitted && !objGarantia.Serie }" />
            <small style="color: red;" class="p-invalid" v-if="submitted && !objGarantia.Serie">El numero de serie es
              requerido.</small>
          </div>
          <div class="p-field" :class="{ 'col-6': modoEdicion === 'Agregar', 'col-12': modoEdicion === 'Editar' }">
            <label for="Id_estatus">Estatus</label>
            <Dropdown id="Id_estatus" v-model="objGarantia.Id_estatus" required :options="status" optionLabel="Label"
              optionValue="Id" placeholder="Selecciona un Estatus"
              :class="{ 'p-invalid': submitted && !objGarantia.Id_estatus }" />
            <small style="color: red;" class="p-invalid" v-if="submitted && !objGarantia.Id_estatus">El estatus es
              requerido.</small>
          </div>
          <div class="p-field col-6" v-if="modoEdicion === 'Agregar'">
            <label for="unidad">Unidad</label>
            <Dropdown id="unidad" v-model="objGarantia.Id_unidad" required :options="lstUnidades" optionLabel="Unidad"
              optionValue="Id_unidad" placeholder="Selecciona una unidad" />
          </div>
          <div class="p-field col-6" v-if="modoEdicion === 'Agregar'">
            <label for="folio">Requerimiento</label>
            <InputText autocomplete="off" id="forio" v-model.trim="objGarantia.Requerimiento" />
          </div>
          <div class="p-field col-12">
            <label for="observaciones">Observaciónes</label>
            <Textarea autocomplete="off" id="observaciones" v-model.trim="objGarantia.Observacion" required
              :class="{ 'p-invalid': submitted && !objGarantia.Observacion }" />
            <small style="color: red;" class="p-invalid" v-if="submitted && !objGarantia.Observacion">Las observaciones
              son
              obligatorias. </small>
          </div>
        </div>
        <template #footer>
          <Button label="Cancelar" icon="pi pi-times" @click="cancelarDialogGaratia" class="p-button-text" />
          <Button label="Guardar" icon="pi pi-check" @click="guardarGarantia" />
        </template>
      </Dialog>
      <Dialog :style="{ width: '650px' }" :visible="showDetalle" :modal="true" class="p-fluid" :closable="false">
        <template #header>
          <h3>Detalles</h3>
        </template>
        <p><b>Imagenes</b></p>
        <Carousel :value="lstImagen" :numVisible="3" :numScroll="3">
          <template #item="slotProps">
            <div class="border-1 surface-border border-round m-2 p-3">
              <div class="mb-3">
                <div @click="verImagenGrande(slotProps.data)">
                  <img :src="slotProps.data" :alt="'Imagen ' + slotProps.index" class="image" />
                </div>
              </div>
            </div>
          </template>
        </Carousel>
        <Dialog :style="{ width: '80%' }" :visible="showImageDialog" :modal="true" :closable="false"
          @hide="closeImageDialog">
          <img :src="selectedImage" alt="Imagen Grande" style="width: 100%; height: auto;" />
          <template #footer>
            <Button label="Cerrar" icon="pi pi-times" @click="closeImageDialog" class="p-button-help" />
          </template>
        </Dialog>
        <p><b>Historial de cambios</b></p>
        <hr />
        <div class="col-12">
          <Panel v-for="objDetalle in lstDetalles" :key="objDetalle.Id_detalle" :header="getHeader(objDetalle)" toggleable
            class="full-width" :collapsed="true">
            <div class="col-12 panel">
              <p><b>Observaciones:</b></p>
              <span class="col-12">{{ objDetalle.Observacion }}</span>
            </div>
          </Panel>
        </div>
        <template #footer>
          <Button label="Cerrar" icon="pi pi-times" class="p-button-help" @click="cancelarDialogoDetalles" />
        </template>
      </Dialog>
      <ConfirmDialog></ConfirmDialog>
      <Toast />
    </div>
  </template>
  <script>
  import Garantias from '../service/PNAEC';
  import Unidades from '../service/Unidades';
  import { mapGetters } from 'vuex';
  import { FilterMatchMode } from 'primevue/api';
  export default {
    data() {
      return {
        filters: {
          'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        },
        submitted: false,
        URLimagen: '',
        ID: '',
        NOMBRE: '',
        NombreAntiguo: '',
        modoEdicion: '',
        pdfURL: '',
        objPNAEC: {},
        objGarantia: {},
        lstPNEC: [],
        lstGarantias: [],
        lstImagen: [],
        lstDetalles: [],
        lstUnidades: [],
        selectedPNAEC: null,
        selectedImage: null,
        loading: false,
        showImageDialog: false,
        showDialogPnaec: false,
        showDialogGarantia: false,
        showDetalle: false,
        showPDFDialog: false,
        objDetalle: {},
        status: [
          { Id: 10, Label: "Nuevo" },
          { Id: 11, Label: "Solicitado" },
          { Id: 12, Label: "Sin proveedor" },
          { Id: 13, Label: "En curso" },
          { Id: 14, Label: "Enviado al proveedor" },
          { Id: 15, Label: "No procede" },
          { Id: 16, Label: "Finalizado" },
        ],
        statusClassMap: {
          10: 'status-nuevo',
          11: 'status-solicitado',
          12: 'status-sin-proveedor',
          13: 'status-en-curso',
          14: 'status-enviado-proveedor',
          15: 'status-no-procede',
          16: 'status-finalizado'
        }
      };
    },
    mounted() {
      var t = this;
      t.CargaInicial();
      t.CargaGarantias();
    },
    methods: {
      getLabelStatus(Id) {
        var statusObj = this.status.find(status => status.Id === Id);
        return statusObj ? statusObj.Label : "Desconocido";
      },
      getStatusClass(idestatus) {
        return this.statusClassMap[idestatus] || 'status-desconocido';
      },
      getFechaWCF(fecha, hora) {
        if (fecha) {
          var millis = fecha
            .replace("/Date(", "")
            .replace("/", "")
            .replace(")", "");
          millis = millis * 1;
          if (millis > 0) {
            var mfecha = new Date(millis);
            var res =
              mfecha.getDate() < 10 ? "0" + mfecha.getDate() : mfecha.getDate();
            res += "/";
            res +=
              mfecha.getMonth() + 1 < 10
                ? "0" + (mfecha.getMonth() + 1)
                : mfecha.getMonth() + 1;
            res += "/";
            res += mfecha.getFullYear();
            if (hora) {
              res += " ";
              res += mfecha.getHours();
              res += ":";
              res +=
                mfecha.getMinutes() < 10
                  ? "0" + mfecha.getMinutes()
                  : mfecha.getMinutes();
            }
            return res;
          } else {
            return "N/D";
          }
        }
      },
      getHeader(objDetalle) {
        var estatus = this.getLabelStatus(objDetalle.Id_estatus);
        var fecha = this.getFechaWCF(objDetalle.Fecha);
        return `${estatus} - Fecha reporte: ${fecha}`;
      },
      CargaInicial() {
        var t = this;
        var pnaecSrv = new Garantias();
        t.loading = true;
        pnaecSrv.getAll(t).then((res) => {
          t.lstPNEC = res;
          t.loading = false;
        });
      },
      CargaGarantias() {
        var t = this;
        var pnaecSrv = new Garantias();
        t.modoEdicion = "TODOS"
        t.loading = true;
        pnaecSrv.getAllGarantias(t).then((res) => {
          t.lstGarantias = res;
          t.loading = false;
          t.ID = '';
          t.NOMBRE = '',
            t.selectedPNAEC = null;
        })
      },
      onRowSelect(event) {
        var t = this;
        t.modoEdicion = '';
        t.ID = event.data.Id_pnaec;
        t.NOMBRE = event.data.Nombre;
        t.loading = true;
        t.cargaGarantiaPNAEC(t.ID);
      },
      cargaGarantiaPNAEC(id) {
        var t = this;
        var pnaecSrv = new Garantias();
        pnaecSrv.getxPNAEC(t, id).then((res) => {
          t.lstGarantias = res;
          t.loading = false;
        }).catch((error) => {
          t.loading = false;
          console.error("Error al cargar garantías:", error);
        });
      },
      verPDF(urlDocumento) {
        var t = this;
        t.pdfURL = t.getUrlServicios + urlDocumento.replace("~/", "")
        t.showPDFDialog = true;
      },
      verNavegador() {
        var t = this;
        window.open(t.pdfURL, '_blank');
      },
      closePDFDialog() {
        this.showPDFDialog = false;
        this.pdfURL = '';
      },
      agregarPNAEC() {
        var t = this;
        t.objPNAEC = {};
        t.modoEdicion = "Agregar";
        t.showDialogPnaec = true;
      },
      editarPNAEC(obj) {
        var t = this;
        t.modoEdicion = "Editar";
        t.objPNAEC = { ...obj };
        t.showDialogPnaec = true;
        t.NombreAntiguo = t.objPNAEC.Nombre
      },
      editarGarantia(obj) {
        var t = this;
        t.modoEdicion = "Editar";
        t.objGarantia = { ...obj };
        t.showDialogGarantia = true;
      },
      guardarPNAEC() {
        var t = this;
        var fileByteArray = [];
        var file = null;
        var newFileName = null;
        this.submitted = true;
        if (!t.objPNAEC.Nombre || !t.objPNAEC.Descripcion) {
          t.mensajes = "Algunos campos son obligatorios";
          return;
        }
        let obj = {
          Id_pnaec: t.objPNAEC.Id_pnaec,
          Nombre: t.objPNAEC.Nombre,
          URL: t.objPNAEC.URL,
          NombreAntiguo: t.NombreAntiguo,
          Descripcion: t.objPNAEC.Descripcion,
          Proveedor: t.objPNAEC.Proveedor,
        };
        if (t.$refs.pdf.files.length > 0) {
          file = t.$refs.pdf.files[0];
          newFileName = file.name;
          var ext = file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2);
          if (ext.length > 0 && ext.length <= 4) {
            if (file.size <= 5000000) {
              var reader = new FileReader();
              reader.readAsArrayBuffer(file);
              reader.onloadend = function (evt) {
                if (evt.target.readyState == FileReader.DONE) {
                  var arrayBuffer = evt.target.result,
                    array = new Uint8Array(arrayBuffer);
                  for (var i = 0; i < array.length; i++) {
                    fileByteArray.push(array[i]);
                  }
                  newFileName = newFileName.replace(" ", "").replace("_", "");
                  obj.DocumentoPDF = {
                    fileName: newFileName,
                    fileBytes: fileByteArray,
                  };
                  t.sendRequest(t, obj)
                }
              };
            }
          }
        } else {
          t.sendRequest(t, obj);
        }
      },
      sendRequest(t, obj) {
        var PNAECSrvr = new Garantias();
        if (t.modoEdicion == "Agregar") {
          let nombreExiste = t.lstPNEC.some(pnaec => pnaec.Nombre.toLowerCase() === t.objPNAEC.Nombre.toLowerCase());
          if (nombreExiste) {
            t.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "El nombre ya existe, por favor elija un nombre diferente.",
              life: 3000,
            });
            return;
          }
          PNAECSrvr.Add(t, obj).then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "PNAEC agregado correctamente",
              life: 3000,
            });
            t.cancelarDialogPNAEC();
            t.CargaInicial();
          });
        } else {
          PNAECSrvr.Update(t, obj).then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "PNAEC editado correctamente",
              life: 3000,
            });
            t.cancelarDialogPNAEC();
            t.CargaInicial();
          });
        }
      },
      guardarGarantia() {
        var t = this;
        t.submitted = true;
        if (!t.objGarantia.Serie || !t.objGarantia.Id_estatus) {
          t.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Algunos campos son requeridos.",
            life: 3000
          });
          return;
        }
        if (t.modoEdicion === "Agregar") {
          var files = t.$refs.img.files;
          var fileByteArrayList = [];
          if (t.$refs.img.files.length === 0) {
            t.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Debe cargar al menos una imagen.",
              life: 3000
            });
            return;
          }
          var promises = Array.from(files).map(file => {
            return new Promise((resolve, reject) => {
              var fileByteArray = [];
              var newFileName = file.name;
              var reader = new FileReader();
              reader.readAsArrayBuffer(file);
              reader.onloadend = function (evt) {
                if (evt.target.readyState === FileReader.DONE) {
                  var arrayBuffer = evt.target.result;
                  var array = new Uint8Array(arrayBuffer);
                  for (var i = 0; i < array.length; i++) {
                    fileByteArray.push(array[i]);
                  }
                  newFileName = newFileName.replace(" ", "").replace("_", "");
                  fileByteArrayList.push({
                    fileName: newFileName,
                    fileBytes: fileByteArray
                  });
                  resolve();
                }
              };
              reader.onerror = function () {
                reject();
              };
            });
          });
          Promise.all(promises).then(() => {
            let obj = {
              Id_garantia: t.objGarantia.Id_garantia,
              Serie: t.objGarantia.Serie,
              Id_estatus: t.objGarantia.Id_estatus,
              Observacion: t.objGarantia.Observacion,
              URL: t.objGarantia.URL,
              Id_pnaec: t.ID,
              Nombre_pnaec: t.NOMBRE,
              Id_unidad: t.objGarantia.Id_unidad,
              Requerimiento: t.objGarantia.Requerimiento,
              ImagenesGarantia: fileByteArrayList
            };
            t.sendRequestGarantia(t, obj);
          }).catch(() => {
            t.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Hubo un problema al procesar las imágenes",
              life: 3000
            });
          });
        } else {
          let obj = {
            Id_garantia: t.objGarantia.Id_garantia,
            Id_estatus: t.objGarantia.Id_estatus,
            Observacion: t.objGarantia.Observacion,
            Id_pnaec: t.objGarantia.Id_pnaec,
          };
          t.sendRequestGarantia(t, obj);
        }
      },
      sendRequestGarantia(t, obj) {
        var PNAECSrvr = new Garantias();
        if (t.modoEdicion == "Agregar") {
          PNAECSrvr.AddGarantia(t, obj).then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Garantia agregada correctamente",
              life: 3000,
            });
            t.cancelarDialogGaratia();
            t.cargaGarantiaPNAEC(t.ID);
          });
        } else {
          PNAECSrvr.UpdateGarantias(t, obj).then(() => {
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Garantia editada correctamente",
              life: 3000,
            });
            t.cancelarDialogGaratia();
          });
        }
      },
      cancelarDialogPNAEC() {
        var t = this;
        t.showDialogPnaec = false;
        t.objPNAEC = {};
        t.submitted = false;
      },
      agregarGarantia() {
        var t = this;
        t.objGarantia = {};
        t.modoEdicion = "Agregar";
        t.showDialogGarantia = true;
        var uniSrv = new Unidades();
        uniSrv.getAll(t).then((res) => {
          t.lstUnidades = res;
        })
      },
      cancelarDialogGaratia() {
        var t = this;
        t.showDialogGarantia = false;
        t.objGarantia = {};
        t.submitted = false;
      },
      detallesGarantia(obj) {
        var t = this;
        var PNAECSrvr = new Garantias();
        var idGarantia = obj.Id_garantia;
        t.showDetalle = true;
        PNAECSrvr.getDetalles(t, idGarantia).then((res) => {
          t.lstDetalles = res.reverse();
          PNAECSrvr.getGarantia(t, idGarantia).then((res) => {
            t.objDetalle = res;
            t.verImagen(t.objDetalle.URL);
          });
        });
      },
      cancelarDialogoDetalles() {
        var t = this;
        t.showDetalle = false;
        t.lstImagen = [];
      },
      verImagen(URLimagen) {
        var t = this;
        var PNAECSrvr = new Garantias();
        var url = URLimagen.replace(/\\/g, '/');
        PNAECSrvr.getImagenes(t, url).then((res) => {
          t.lstImagen = res.map(img => {
            let fullPath = `${url}/${img}`.replace("~/", "");
            return `${t.getUrlServicios}${fullPath}`;
          });
        });
      },
      verImagenGrande(imageURL) {
        this.selectedImage = imageURL
        this.showImageDialog = true;
      },
      closeImageDialog() {
        this.showImageDialog = false;
      },
      eliminarGarantia(obj) {
        var t = this;
        console.log("objeto a eliminar", obj);
        var idGarantia = obj.Id_garantia;
        var urlGarantia = obj.URL;
        var idPnaec = obj.Id_pnaec;
        t.$confirm.require({
          message: "Esta accion es irreversible ¿Quieres continuar?",
          header: 'Confirmación',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Si',
          rejectLabel: 'No',
          accept: () => {
            var PNAECSrvr = new Garantias();
            PNAECSrvr.deleteGarantia(t, idGarantia, urlGarantia).then(() => {
              t.$toast.add({
                severity: "success",
                summary: "AVISO",
                detail: "Garantia eliminada correctamente",
                life: 3000,
              });
            })
            t.cargaGarantiaPNAEC(idPnaec);
          },
          reject: () => {
          }
        });
      },
      eliminarPNAEC(obj) {
        var t = this;
        var idPnaec = obj.Id_pnaec;
        var urlPnaec = obj.URL;
        t.$confirm.require({
          message: "Se eliminarán todo lo relacionado a este PNAEC ¿Quieres continuar?",
          header: 'Confirmación',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Si',
          rejectLabel: 'No',
          accept: () => {
            var PNAECSrvr = new Garantias();
            PNAECSrvr.deletePNAEC(t, idPnaec, urlPnaec).then(() => {
              t.$toast.add({
                severity: "success",
                summary: "AVISO",
                detail: "Garantia eliminada correctamente",
                life: 3000,
              });
            })
            t.CargaInicial();
            t.CargaGarantias();
          },
          reject: () => {
          }
        });
      }
    },
    computed: {
      ...mapGetters(['getUrlServicios', 'getUsuarioLogueado']),
    }
  }
  </script>
  <style scoped>
  .custom-margin {
    margin-right: 3px;
  }
  .data-tables-container {
    display: flex;
    justify-content: space-between;
  }
  .full-width {
    width: 100%;
  }
  .image {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
  .table-header {
    display: flex;
    justify-content: space-between;
    -webkit-box-pack: justify;
  }
  .panel {
    overflow: auto;
    word-wrap: break-word;
  }
  .panel span {
    padding: 0;
    margin: 0;
  }
  </style>